import React from 'react';
import { tagStyles, tagEmoji, getTagLabels, normalizeBackendMediaType } from '../../../utils/tagStyles';
import { useTranslation } from 'react-i18next';

interface TagPillProps {
  tag?: string | null;
}

export const TagPill: React.FC<TagPillProps> = ({ tag }) => {
  const { t } = useTranslation();
  const tagLabel = getTagLabels(t);
  if (!tag) return null;
  const variant = normalizeBackendMediaType(tag || undefined);
  if (!variant) return null;
  const s = (tagStyles as Record<string, { bg: string; text: string; border: string }>)[variant];
  if (!s) return null;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${s.bg} ${s.text} ${s.border}`}>
      <span>{(tagEmoji as Record<string, string>)[variant]}</span>
      <span>{(tagLabel as Record<string, string>)[variant]}</span>
    </span>
  );
};


